/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import {
  CloudResponse, CloudState, CustomerCloud, RenewResponse, ServerOrderMutation,
} from './types';
import { MutationRequestError, MutationRequestStatus } from '../types';

export const mutations: MutationTree<CloudState> = {
  cloudsLoading(state): void {
    state.clouds.error = undefined;
    state.clouds.data = undefined;
    state.clouds.status = MutationRequestStatus.LOADING;
  },
  cloudsLoaded(state, payload: CloudResponse): void {
    state.clouds.error = undefined;

    const createDateFromString = (s): Date => {
      const token = s.split(/[^0-9]/);
      return new Date(token[0], token[1] - 1, token[2], token[3], token[4], token[5]);
    };

    Object.entries(payload).forEach(([, cloud]) => {
      cloud.deactivated = cloud.deactivated
        ? new Date(cloud.deactivated)
        : null;
      cloud.preorder = cloud.preorder
        ? new Date(cloud.preorder)
        : null;
      cloud.deletion = cloud.deletion
        ? createDateFromString(cloud.deletion)
        : null;
      cloud.active_until = cloud.active_until
        ? createDateFromString(cloud.active_until)
        : null;
    });

    state.clouds.data = payload;
    state.clouds.status = MutationRequestStatus.SUCCESS;
  },
  serversSorted(state, payload: ServerOrderMutation): void {
    state.clouds.error = undefined;

    Object.entries(state.clouds.data)
      .filter(([key]) => key === payload.orderId)
      .forEach(([key, cloud]) => {
        (cloud as CustomerCloud).products = payload.products;
      });
  },
  cloudsError(state, payload: MutationRequestError<null>): void {
    state.clouds.data = undefined;
    state.clouds.error = payload;
    state.clouds.status = MutationRequestStatus.ERROR;
  },
  renewLoading(state) {
    state.renew.error = undefined;
    state.renew.data = undefined;
    state.renew.status = MutationRequestStatus.LOADING;
  },
  renewLoaded(state) {
    state.renew.error = undefined;
    state.renew.data = undefined;
    state.renew.status = MutationRequestStatus.SUCCESS;
  },
  renewError(state, payload: MutationRequestError<null>) {
    state.renew.data = undefined;
    state.renew.error = payload;
    state.renew.status = MutationRequestStatus.ERROR;
  },
  cloudRenewUpdated(state, payload: RenewResponse) {
    if (state.clouds.data !== undefined) {
      Object.entries(state.clouds.data)
        .forEach(([, cloud]) => {
          if (payload.orderId === cloud.id) {
            cloud.renew = payload.status;
          }
        });
    }
  },
};
